import { createContext } from 'react'

/**
 * チャットコンテキストの定義
 *
 * Provider コンポーネント (ChatContext.tsx) と分離しているのは、
 * コンポーネント以外を export すると react-refresh (HMR) が
 * ファイル単位の高速リロードをできなくなるため。
 * フック本体は hooks/useChat.ts にある。
 */

export interface ChatMessage {
  messageId: string
  userId: string
  userName: string
  message: string
  createdAt: string
  timestamp?: string
}

export interface OnlineMember {
  userId: string
  userName: string
  status: string
  displayName?: string
}

export interface ChatContextValue {
  messages: ChatMessage[]
  onlineMembers: OnlineMember[]
  typingUsers: Set<string>
  sendMessage: (message: string) => Promise<void>
  setTyping: (isTyping: boolean) => Promise<void>
  connected: boolean
  fetchOnlineMembers: () => Promise<void>
  fetchMessageHistory: () => Promise<void>
  isLoadingHistory: boolean
}

export const ChatContext = createContext<ChatContextValue | null>(null)
